import { keyMirror } from 'utils/keyMirror';

export const ActionTypes = keyMirror(
  {
    SET_SCREEN_DEFINITIONS: null,
  },
  'ScreenDefinitions',
);
